<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center px-4">
    <div class="max-w-md w-full">
      <div class="bg-white rounded-lg shadow-sm p-8">
        <div class="text-center">
          <!-- Spinner -->
          <div class="flex justify-center mb-6">
            <div class="animate-spin rounded-full h-16 w-16 border-b-4 border-wiq-green"></div>
          </div>

          <h1 class="text-2xl font-bold text-gray-900 mb-4">
            Launching WrestlingIQ Kiosk
          </h1>

          <p v-if="error" class="text-red-600 mt-4">
            Unable to launch kiosk. Please double check your internet connection and refresh the page.<br /><br />
            Contact support@wrestlingiq.com if the issue persists.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KioskLoading',
  props: {
    error: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
